<template>
  <div>
    <a-button type="primary" @click="handleSub" style="margin-bottom: 20px">确认选择</a-button>
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      hideDefaultSelections="false"
      :row-selection="rowSelection"
      :pagination="false"
      :bordered="tableBordered"
    >
      <div slot="sort" slot-scope="text, record">
        <!-- <a-input-number :min="1" v-model="record.sort" @change="handleChage(record)" placeholder="请输入" allow-clear /> -->
        <a-input-number :min="1" v-model="record.sort" placeholder="请输入" allow-clear />
      </div>
      <span slot="required" slot-scope="text, record">
        <a-radio-group v-model="record.required" button-style="solid">
          <a-radio-button :value="true"> 是 </a-radio-button>
          <a-radio-button :value="false"> 否 </a-radio-button>
        </a-radio-group>
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['abm-fix:model:edit']"> 修改 </a>
        <a-divider type="vertical" v-hasPermi="['abm-fix:model:remove', 'abm-fix:model:status']" />
        <a-dropdown v-hasPermi="['abm-fix:model:remove', 'abm-fix:model:status']">
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            <a-icon type="double-right" />
            更多
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-hasPermi="['abm-fix:model:remove']">
              <a @click="handleDelete(record)" v-hasPermi="['abm-fix:model:remove']"> 删除 </a>
            </a-menu-item>
            <a-menu-item v-hasPermi="['abm-fix:model:status']">
              <a @click="handleDeletes(record)" v-hasPermi="['abm-fix:model:status']">
                {{ record.status == 0 ? '禁用' : '启用' }}
              </a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>
  </div>
</template>
  
  <script>
import { publicTant, manyfile } from '@/api/pressure/mode'
import { getTenant, updateTenant } from '@/api/system/tenant'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'Post',
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: ['tenantId', 'deList'],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: false,
        getCheckboxProps: (record) => ({
          props: {
            disabled: true, // Column configuration not to be checked
            name: record.name,
          },
        }),
      }
    },
  },
  data() {
    return {
      list: [],
      tableList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 8,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      dataForm: {},
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '是否必填',
          dataIndex: 'required',
          align: 'center',
          scopedSlots: { customRender: 'required' },
        },
        {
          title: '排序',
          dataIndex: 'sort',
          align: 'center',
          scopedSlots: { customRender: 'sort' },
        },
        // {
        //   title: '设备编号',
        //   dataIndex: 'devCode',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '租户简称',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
      ],
    }
  },
  filters: {},
  created() {
    this.getMo()
    // this.tableList = this.deList
    // let arr = []
    // if (this.deList.length) {
    //   this.devList.forEach((v) => {
    //     arr.push(v.modelId)
    //   })
    // }
    // this.selectedRowKeys=arr
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getMo() {
      console.log(this.tenantId, 'tenantIdtenantId')
      getTenant(this.tenantId).then((res) => {
        console.log(res, '的点点滴滴买买买')
        this.dataForm = res.data
        this.tableList = res.data.acquiesceFileOptionIds
        this.getList()
      })
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      manyfile(this.queryParam).then((response) => {
        response.data.forEach((v, index) => {
          v.id = v.type.toString()
          v.required = false
          console.log(this.tableList, 'this.tableListthis.tableList')
          if (this.tableList && this.tableList.length) {
            this.tableList.forEach((item) => {
              if (item.type == v.type) {
                v.required = item.required
                v.sort = item.sort
                this.selectedRowKeys.push(v.id)
              } 
              // else {
              //   v.required = false
              // }
            })
          } 
          // v.required = false

        })
        this.list = response.data
        this.loading = false
      })
    },
    getRows(props, event) {
      console.log(props)
      props.onExpand(props.record, event)
    },
    handleSub() {
      console.log(this.selectedRowKeys, 'selectedRowKeys')
      const arr = []
      this.list.forEach((v) => {
        this.selectedRowKeys.forEach((item) => {
          if (v.id === item) {
            arr.push(v)
          }
        })
      })
      this.dataForm.acquiesceFileOptionIds = arr
      console.log(this.dataForm, ' this.dataForm this.dataForm')
      updateTenant(this.dataForm).then((res) => {
        this.$message.success('提交成功', 3)
        this.$emit('backTable')
      })
      // addModel(query).then((res) => {
      //   this.$message.success('提交成功', 3)
      //   this.$emit('backTable')
      // })
    },
    /**
     * @param {Object} row 子表格的数据行
     * @param {parentRow} row 父表格行数据
     */
    onGetInnerRow(row, parentRow) {
      console.log(row)
      console.log(parentRow)
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    handleChage(e) {
      console.log(e, '的点点滴滴')
      //   let leg = false
      const index = this.list.findIndex((item) => item.id == e.id)
      const indexs = this.selectedRowKeys.findIndex((item) => item == e.id)
      console.log(indexs, '顶顶顶顶8999')
      console.log(index, '顶顶顶顶')
      console.log(e.sort, '顶顶顶顶')
      console.log(this.selectedRowKeys, '顶顶顶顶')
      if (indexs == -1) {
        if (e.sort) {
          this.selectedRowKeys.push(e.id)
        } 
        // else {
        //   this.selectedRowKeys.splice(index, 1)
        // }
      } else {
        this.selectedRowKeys.splice(index, 1)
      }
      // if(inde)

      console.log(this.tableList, 'this.tableListthis.tableList')
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 200,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      console.log(pageSize, '顶顶顶顶ttt')
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      console.log(pageSize, '顶顶顶顶ttt444')

      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
      this.list.forEach((v) => {
        this.tableList.forEach((item) => {
          if (v.id == item.modelId) {
            v.sort = item.sort
          }
        })
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      //   console.log(selectedRows,'selectedRowsselectedRowsselectedRows')
      //   console.log(selectedRowKeys,'selectedRowKeys')
      this.ids = this.selectedRows.map((item) => item.id)
      // this.selectedRows = this.ids
      //   let arr=this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
      this.$forceUpdate()
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 禁用启用
    handleDeletes(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      const text = row.status === 0 ? '是否要禁用此数据?' : '是否要启用此数据?'
      this.$confirm({
        title: text,
        onOk() {
          return statusObj({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
  